<template>
  <v-flex xs12 d-flex text-xs-center>
    <v-layout row wrap align-center>
      <v-flex xs2 text-xs-center>
        <v-tooltip top>
          <template v-slot:activator="{ exitToolTip }">
            <v-btn
              small
              icon
              fab
              color="error"
              dark
              v-on="exitToolTip"
              @click="redirectSkillersHomePage()"
              class="quitButton"
            >
              <v-icon>highlight_off</v-icon>
            </v-btn>
          </template>
          <span>Kilépés</span>
        </v-tooltip>
      </v-flex>
      <v-flex xs3 text-xs-center>
        <v-card flat class="currentResults">
          <v-layout row wrap text-xs-center>
            <v-flex xs12class="stat">
              <img
                :src="require('@/assets/img/footprint_mod_1.png')"
                class="statusImages"
              />
              {{ stepCounter }}
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs3 text-xs-center>
        <v-card flat class="currentResults">
          <v-layout row wrap text-xs-center>
            <v-flex xs12 class="stat">
              <img
                :src="require('@/assets/img/new_lingron.png')"
                class="statusImages"
              />
              {{ lingronCounter }}
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs3 text-xs-center>
        <v-card flat class="currentResults">
          <v-layout row wrap text-xs-center>
            <v-flex xs12 class="stat">
              <!-- <img :src="require('@/assets/img/footprint_mod_1.png')" class="statusImages">
                          {{ stepCounter }} -->
              <v-chip class="pa-2 mt-3 headerPoints margin-y" color="#F9F871">
                <!-- +{{ points }} pont -->
                +{{ stepCounter + lingronCounter }} pont
              </v-chip>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
export default {
  props: ["stepCounter", "lingronCounter", "maxLingron", "fromStepField"],
  methods: {
    redirectSkillersHomePage() {
      window.location.replace("https://skillersnyelviskola.hu");
    }
  }
};
</script>

<style lang="scss" scoped></style>
